import {CATEGORY_PROMOTIONAL_PRODUCTS} from '../constants/categoryConstants';
import {septemberPromoTrendingBannerTest as flag} from '../constants/signalmanConstants';
import {TEST_EXPIRY_DATE} from './hardgoodsPromoTest';

const SEPTEMBER_PROMO_TRENDING_BANNER_TEST_CATEGORIES = [
  CATEGORY_PROMOTIONAL_PRODUCTS
];

export const septemberPromoTrendingBannerTest = () => {
  return flag === 'test';
};

export const septemberPromoTrendingBannerTestEligible = (categoryId) => {
  return (
    septemberPromoTrendingBannerTest() &&
    SEPTEMBER_PROMO_TRENDING_BANNER_TEST_CATEGORIES.includes(
      Number(categoryId)
    ) &&
    new Date() < new Date(TEST_EXPIRY_DATE)
  );
};

export const septemberPromoTrendingBannerControl = () => {
  return flag === 'control';
};

export const septemberPromoTrendingBannerControlEligible = (categoryId) => {
  return (
    septemberPromoTrendingBannerControl() &&
    SEPTEMBER_PROMO_TRENDING_BANNER_TEST_CATEGORIES.includes(
      Number(categoryId)
    ) &&
    new Date() < new Date(TEST_EXPIRY_DATE)
  );
};
